import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const GoogleBusinessServices: React.FC = () => <PlatformServicePage platform="google" />;
export default GoogleBusinessServices;
